var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-sections"}},[_c('div',{attrs:{"id":"mobile-menu"}},[_c('MobileMenu')],1),_c('div',{attrs:{"id":"Allsections"}},[_c('Section1'),_c('Section2'),_c('Section3'),_c('Section4')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }